import React from 'react'
import { connect } from 'react-redux'
import { makeStyles } from '@material-ui/core/styles'
import { history } from '../../../_state/helpers'
import OrganizationOverviewSidebar from './Components/OrganizationOverviewSidebar'
import CourseStatisticsTabBar, { CourseStatisticsTab } from '../../../Components/CourseStatistics/CourseStatisticsTabBar'
import CourseStatisticsContent from '../../../Components/CourseStatistics/CourseStatisticsContent'

const useStyles = makeStyles(() => ({
    root: {
        minHeight: '300px',
        marginLeft: 'calc(15% + 25px)',
        marginRight: '25px',
        paddingBottom: '60px',
    },
}))

/**
 * Organization wide course statistics. Sits behind the Statistics sidebar entry as a second tab,
 * so it inherits the same route permissions as the existing statistics page.
 */
const OrganizationCourseStatistics = (props) => {
    const classes = useStyles()

    const handleTabChange = (tab) => {
        if (tab === CourseStatisticsTab.Overview) {
            history.push('/dashboard/statistics')
        }
    }

    return (
        <div className={classes.root}>
            <OrganizationOverviewSidebar path={props.computedMatch?.path} />
            <CourseStatisticsTabBar activeTab={CourseStatisticsTab.Courses} onChange={handleTabChange} />
            <CourseStatisticsContent organizationId={props.organization.selectedOrganization} />
        </div>
    )
}

function mapStateToProps(state) {
    const { organization, user } = state
    return {
        organization,
        user,
    }
}

export default connect(mapStateToProps)(OrganizationCourseStatistics)
